import React from 'react';
import { BaseStagePlugin, StageScaleView, useActiveOriginIndex } from '@/framework';
import { IExportPlugin, PluginType } from '@/version-types';
import { IntelligentColorPlugin } from './controller';
import { useInit } from './hooks/use-init';
import intelligentColorPluginState, { useIntelligentColorState } from './states/intelligent-color-state';
import { ColorPickPen } from './views/color-pick-pen';
import { SmartMaskPen } from './views/smart-mask-pen';

const IntelligentColorPluginView: React.FC = React.memo(() => {
    const originIndex = useActiveOriginIndex();
    const isProtectPen = useIntelligentColorState()((state) => state.isProtectPen);
    const isOpenIntelligentPickColor = useIntelligentColorState()((state) => state.isOpenIntelligentPickColor);

    useInit();

    if (!isProtectPen && !isOpenIntelligentPickColor) return null;

    return (
        <BaseStagePlugin enablePointerEvents originIndexOrLayerId={originIndex} name="intelligent-color">
            {/* ATTENTION: 统一在外层进行缩放，内部按照实际尺寸进行绘制 */}
            <StageScaleView originIndex={originIndex}>
                {isOpenIntelligentPickColor && <ColorPickPen />}
                {isProtectPen && <SmartMaskPen />}
            </StageScaleView>
        </BaseStagePlugin>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 10,
    name: 'intelligent-color',
    render() {
        return <IntelligentColorPluginView />;
    },
    createInstance({ identity }) {
        return [{ key: 'IntelligentColorPlugin', value: new IntelligentColorPlugin(identity) }];
    },
    createState() {
        return [intelligentColorPluginState];
    },
};

export default exportPlugin;
